/* eslint-disable-next-line no-unused-vars */
const productPropertiesInterfaceKR = `
	id
	sku
	name
	campaign_discount_price
	campaign_discount_disclaimer
	related_samples {
		name
		sku
		stock_status
	}
	promo_label_data {
        name
        image
        priority
      }
	subscription {
		is_subscription_enabled
		min_qty
		max_qty
	}
	brand
	comdty_code
	product_code
	image {
		url
		label
	}
	small_image {
		url
		label
	}
	media_gallery {
	   url
	   disabled
		... on ProductVideo {
			video_content {
				video_url
			}
       }
	}
	price_range {
		maximum_price {
			regular_price {
				value
				currency
			}
		}
		minimum_price {
			regular_price {
				value
				currency
			}
			final_price {
				value
				currency
			}
			discount {
				amount_off
				percent_off
			}
		}
	}
	stock_status
	type_id
	max_qty
	short_description {
		html
	}
	product_ribbon_label_name
	parent_id
	glojp_aem_url
	rating_summary
    review_count
`;

const isDiscontinued = `
	discontinued{
		online
		both
}`;

const productPropertiesInterfacePLPKR = `
	id
	sku
	name
	campaign_discount_price
	campaign_discount_disclaimer
	comdty_code
	promo_label_data {
        name
        image
        priority
      }
	subscription {
		is_subscription_enabled
		min_qty
		max_qty
	}
	price_range {
		maximum_price {
			regular_price {
				value
				currency
			}
		}
		minimum_price {
			regular_price {
				value
				currency
			}
			final_price {
				value
				currency
			}
			discount {
				amount_off
				percent_off
			}
		}
	}
	stock_status
	type_id
	max_qty
	product_ribbon_label_name
	glojp_aem_url
	parent_id
	image {
		url
		label
	}
	small_image {
		url
		label
	}
`;
const productPropertiesInterfaceCartKR = `
	id
	sku
	name
	brand
	subscription {
		is_subscription_enabled
		min_qty
		max_qty
	}
	small_image {
		url
		label
	}
	price_range {
		maximum_price {
			regular_price {
				value
				currency
			}
		}
		minimum_price {
			regular_price {
				value
				currency
			}
			final_price {
				value
				currency
			}
			discount {
				amount_off
				percent_off
			}
		}
	}
	stock_status
	type_id
	max_qty
	glojp_aem_url
	comdty_code
`;
const productPropertiesInterfaceSortKR = `
    id
    sku
    name
	campaign_discount_price
	campaign_discount_disclaimer
    price_range {
        maximum_price {
            regular_price {
                value
                currency
            }
        }
        minimum_price {
            regular_price {
                value
                currency
            }
            final_price {
                value
                currency
            }
            discount {
                amount_off
                percent_off
            }
        }
    }  
    glojp_aem_url
`;
/* eslint-disable-next-line no-unused-vars */
const productReviewsInterfaceKR = `
	reviews (
		pageSize: 50
    currentPage: 1)
	{
		items {
			summary
			text
			nickname
			created_at
			ratings_breakdown {
				name
				value
			}
		}
	}
`;

const customProductPropertiesInterfaceKR = `
	glo_colour
	glo_jp_colour
	glo_jp_colour_value
	glo_jp_category_value
	glo_jp_flavour
	glo_jp_flavour_value
	glo_jp_flavour_type
	glo_jp_flavour_type_value
	glo_strength_fragnance
	glo_strength_fragnance_capsule
	glo_strength_fragnance_label
	glo_strength_tobacco
	glo_strength_tobacco_capsule
	glo_strength_tobacco_label
	glo_strength_menthol
	glo_strength_menthol_capsule
	glo_strength_menthol_label
	glo_hyper_side_panel_colour
	glo_hyper_main_body_colour
	jp_bundle_type
	jp_bundle_type_value
	jp_dedicated_device
	jp_dedicated_device_value
	jp_bundle_regular_price
	campain_description
	jp_campaign_any
	jp_campaign_new_joiner
	jp_campaign_pre_launch
	glovelo_suggestion_sku
	`;
const customProductPropertiesInterfaceSortKR = `
	glo_jp_colour
	glo_jp_colour_value
	glo_jp_category_value
	glo_jp_flavour
	glo_jp_flavour_value
	glo_jp_flavour_type
	glo_jp_flavour_type_value
	jp_bundle_type
	jp_bundle_type_value
	jp_dedicated_device
	jp_dedicated_device_value
	jp_bundle_regular_price
	
`;
const customProductPropertiesInterfaceCartKR = `
	jp_bundle_type
	jp_bundle_type_value
	jp_dedicated_device
	jp_bundle_regular_price
	
	
`;
const customProductPropertiesInterfacePLPKR = `
	glo_jp_colour
	glo_jp_colour_value
	glo_jp_category_value
	glo_jp_flavour
	glo_jp_flavour_value
	glo_jp_flavour_type
	glo_jp_flavour_type_value
	glo_strength_fragnance
	glo_strength_fragnance_capsule
	glo_strength_fragnance_label
	glo_strength_tobacco
	glo_strength_tobacco_capsule
	glo_strength_tobacco_label
	glo_strength_menthol
	glo_strength_menthol_capsule
	glo_strength_menthol_label
	glo_hyper_side_panel_colour
	glo_hyper_main_body_colour
	jp_bundle_type
	jp_bundle_type_value
	jp_dedicated_device
	jp_dedicated_device_value
	jp_bundle_regular_price
	jp_campaign_any
	jp_campaign_new_joiner
	jp_campaign_pre_launch
	glovelo_suggestion_sku
`;

/* eslint-disable-next-line no-unused-vars */
const categoryListInterfaceKR = `
	id
	name
	products {
		items {
			${customProductPropertiesInterfaceSortKR}
			${productPropertiesInterfaceSortKR}
			glo_jp_has_capsule 
			glo_jp_has_capsule_value
		}
	}
	product_count
	children {
		id
		name
		products {
			items {
				${customProductPropertiesInterfaceSortKR}
				${productPropertiesInterfaceSortKR}
				glo_jp_has_capsule 
				glo_jp_has_capsule_value
			}
		}
		product_count
	}
`;

/* eslint-disable-next-line no-unused-vars */
const configurableInterfaceKR = `
	... on ConfigurableProduct {
		configurable_options {
			attribute_code
			label
			values {
				label
				value_index
				eng_label
			}
		}
		variants {
			product {
				${customProductPropertiesInterfaceKR}
				${productPropertiesInterfaceKR}
				${isDiscontinued}
			}
		}
	}
`;
const configurableInterfacePLPKR = `
	... on ConfigurableProduct {
		configurable_options {
			attribute_code
			label
			values {
				label
				value_index
				eng_label
			}
		}
		variants {
			product {
				${customProductPropertiesInterfacePLPKR}
				${productPropertiesInterfacePLPKR}
				${isDiscontinued}
			}
		}
	}
`;
/* eslint-disable-next-line no-unused-vars */
const bundleInterfaceKR = `
	... on BundleProduct {
		items {
			option_id
			options {
				id
				label
				price
				price_type
				product {
					${productPropertiesInterfaceKR}
				}
				quantity
			}
			sku
			title
			type
		}
		price_view
		ship_bundle_items
	}
`;
const bundleInterfacePLPKR = `
	... on BundleProduct {
		items {
			option_id
			options {
				id
				label
				price
				price_type
				product {
					${productPropertiesInterfacePLPKR}
				}
				quantity
			}
			sku
			title
			type
		}
		price_view
		ship_bundle_items
	}
`;

/* eslint-disable-next-line no-unused-vars */
const relatedProductsInterfaceKR = `
	related_products {
		${productPropertiesInterfaceKR}
		${configurableInterfaceKR}
	}
`;
const relatedProductsInterfacePLPKR = `
	related_products {
		${productPropertiesInterfacePLPKR}
		${configurableInterfacePLPKR}
	}
`;

/* eslint-disable-next-line no-unused-vars */
const cartInterfaceKR = `
	items (sortBySubscription: SUBSCRIPTION_FIRST) {
		id
		tax_percent
		product {
			${productPropertiesInterfaceCartKR}
			${customProductPropertiesInterfaceCartKR}
			... on BundleProduct {
			  items {
				option_id
				options {
				  id
				  label
				  product {
					id
					sku
					name
					comdty_code
					glojp_aem_url
					stock_status
					jp_bundle_type
					price_range {
					  minimum_price {
						final_price {
						  value
						  currency
						}
					  }
					}
				  }
				}
			  }
			}
		}
		prices {
			discounts {
				label
			}
			row_total_including_tax {
				value
				 currency
			}
		}
		... on BundleCartItem {
            bundle_options {
                id
                label
                values {
                	id
                    label
                    quantity
                }
            }
        }
		... on ConfigurableCartItem {
			configurable_options {
				id
				option_label
				value_label
			}
		}
		quantity
		subscription_data {
			is_subscription_item
		}
	}
	prices {
		discounts {
			amount {
				value
				currency
			}
			label
		}
		grand_total {
			value
			currency
		}
		subtotal_including_tax {
			value
			currency
		}
		
	}
	customprices {
		grand_total_excluding_shipping_payment_fees {
			value
			currency
		}
	}
	total_quantity
`;
